// src/pages/Resources.js 
import React from 'react'

const Resources = () => {
  return (
    <div className='content pageStyle'>
        <h1 className='pageTitle'>Resources</h1>
        <div className='divider'></div>
        <p className='pageContent'>Hempen halter quarterdeck ahoy execution dock hearties Sea Legs bilged on her anchor. Black jack rope's end execution dock piracy lee topgallant rutters. Cable ho gangway fore driver lass hearties.</p>
        <p className='pageContent'>Draught haul wind Cat o'nine tails overhaul starboard tender plunder. Brethren of the Coast gibbet parley quarter grapple rope's end wench. Cable man-of-war line bowsprit loot gangway bring a spring upon her cable.
        </p>
        <p className='pageContent'>Hogshead matey ye ballast spike fire in the hole black jack. Deadlights knave provost six pounders transom grog blossom capstan. Crimp Plate Fleet Yellow Jack tack swab hardtack lanyard.</p>
    </div>
  )
}

export default Resources 